// components/Pages/Account.jsx
import React from "react";

function Account() {
  return (
    <div className="max-w-4xl mx-auto">
      <h1 className="text-2xl font-bold mb-6">Account</h1>
      <div className="bg-white rounded-2xl shadow p-6">
        <p>Account settings and preferences will be displayed here.</p>
      </div>
    </div>
  );
}

export default Account;